import { render, staticRenderFns } from "./ArtListDOMItemAFA.vue?vue&type=template&id=3edbd1aa&"
import script from "./ArtListDOMItemAFA.vue?vue&type=script&lang=js&"
export * from "./ArtListDOMItemAFA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports